var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3522 0L23.4996 5.18518C24.0626 15.6989 21.5089 20.858 12.3522 28C10.2234 26.3407 8.44362 24.7973 6.96461 23.2585C12.6907 21.0393 15.3659 18.8658 18.0559 15.037C13.8509 18.1967 10.8906 20.0933 5.32212 21.3956C4.25877 20.0687 3.4007 18.7124 2.71779 17.2571C10.3327 15.8873 14.8633 12.5281 17.0188 9.7037C16.7985 9.83088 16.5709 9.96411 16.3351 10.1021C13.3777 11.8331 9.13168 14.3183 1.85509 15.0944C1.44887 13.8766 1.13989 12.579 0.913985 11.1688C6.13408 9.97417 8.85154 8.80475 11.8336 6.74074C8.69937 8.10276 6.19841 8.8965 0.67576 9.36305C0.538836 8.0699 0.458646 6.68414 0.42627 5.18518L12.3522 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5364054133505fb6d0c13928e3ccbc1b.svg";
export { ForwardRef as ReactComponent };